export default (cardNumber) => {
  return cardNumber.toString().replace(/\s+|-/g, '');
};



/** WEBPACK FOOTER **
 ** ./modules/credit-card/stripSeparators.js
 **/